/**
 * Pluralisation (plan v3, phase 8).
 *
 * Remplace les « candidat(s) évalué(s) » recopiés d'écran en écran. Le « (s) »
 * n'est pas qu'inélégant : il se lit littéralement au lecteur d'écran, et il
 * masque que 0 et 1 ne s'écrivent pas pareil.
 *
 * Règle française appliquée : le pluriel commence à 2. `0 candidat` s'écrit au
 * singulier, contrairement à l'anglais.
 */

/** Le mot accordé, sans le nombre : `motPluriel(0, "candidat")` → `candidat`. */
export function motPluriel(
  nombre: number,
  singulier: string,
  pluriel?: string,
): string {
  return Math.abs(nombre) >= 2 ? (pluriel ?? `${singulier}s`) : singulier;
}

/**
 * Le nombre et le mot accordé : `pluriel(3, "candidat")` → `3 candidats`.
 *
 * Pour un pluriel irrégulier, passer la forme complète :
 * `pluriel(2, "travail", "travaux")`.
 */
export function pluriel(
  nombre: number,
  singulier: string,
  formePluriel?: string,
): string {
  return `${nombre} ${motPluriel(nombre, singulier, formePluriel)}`;
}
